import React, { useContext, useRef } from "react";
import { images } from "../../constants";
import Input from "../UI/input/Input";
import Button from "../UI/button/Button";
import classes from "./ForgotPassword.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { useForgotPasswordMutation } from "../../api/authApi";

interface ForgotPasswordData {
    email: string;
}

function ForgotPasswordBox() {
    const userNameRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();
    const [ForgotPassword, { isLoading }] = useForgotPasswordMutation();
    const dispatch = useDispatch();

    const ForgotPasswordHandler = async (e: React.FormEvent) => {
        e.preventDefault();
        const email = userNameRef.current?.value || "";
        if (!email) {
            toast.error("Please enter both username and password");
            return;
        }

        const credentials: ForgotPasswordData = { email };
        try {
            const data = await ForgotPassword(credentials).unwrap();
            console.log("ForgotPassword Response:", data);
            toast.success(data?.message)
            navigate("/login")

        } catch (err: any) {
            const errorMessage =
                err?.data?.message || err?.error || "Invalid credentials";
            toast.error(errorMessage);
        }
    };

    return (
        <div className={classes.container}>
            <div className={classes.ForgotPasswordBox}>
                <div className={classes.logo}>
                    <img src={images.logo} alt="digikala" />
                </div>
                <h2 className={classes.title}>Forgot Password</h2>
                <form onSubmit={ForgotPasswordHandler}>
                    <Input
                        ref={userNameRef}
                        type="text"
                        id="Email"
                        placeholder="Enter Registered Email"
                    />
                    <Button type="submit"
                        disabled={isLoading}
                    >
                        {isLoading ? "Sending Mail..." : "Submit"}
                    </Button>
                </form>
            </div>
            {/* <div className={classes.keyPic}>
        <img
          src={require("../../assets/images/Revenue-cuate.svg").default}
          alt="illustrator key"
        />
      </div> */}
        </div>
    );
}

export default ForgotPasswordBox;
